export default {
        path: '/estudante/:academic_code',
        name: 'Student',
        meta: {
            requiresAuth: true,
            authorizedUsers: ['admin', 'staff', 'faculty', 'student']
        },
        component: () => import('./Student')
    }  
